import moment from 'moment';

export default class DashboardFilters {
    now() {
        return moment();
    }
    filters = {
        PendingTransactions: {
            label: 'Total Pending Transactions',
            type: 'dashboard',
            filter: { where: { status: 'pending' } },
        },
        ActiveLisitings: {
            label: 'Total Active Listings',
            type: 'dashboard',
            filter: { where: { and: [{ status: 'active' }, { origin: 'Listing' }] } },
        },
        TotalPendingInvoicedFiles: {
            label: 'Total Pending Invoiced Files',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        { status: 'pending' },
                        { or: [{ checkStatus: { nin: ['promotional', 'first_file'] } }, { checkStatus: null }] },
                    ],
                },
            },
        },
        NewTransactionCountsToday: {
            label: 'New Transactions - Today',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('date')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Transaction' },
                    ],
                },
            },
        },
        NewTransactionCountsWtd: {
            label: 'New Transactions - WTD',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('week')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Transaction' },
                    ],
                },
            },
        },
        NewTransactionCountsMtd: {
            label: 'New Transactions - WTD',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('month')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Transaction' },
                    ],
                },
            },
        },
        NewTransactionCountsYtd: {
            label: 'New Transactions - YTD',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('year')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Transaction' },
                    ],
                },
            },
        },
        NewListingCountsToday: {
            label: 'New Listings - Today',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('date')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Listing' },
                    ],
                },
            },
        },
        NewListingCountsWtd: {
            label: 'New Listings - WTD',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('week')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Listing' },
                    ],
                },
            },
        },
        NewListingCountsMtd: {
            label: 'New Listings - WTD',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('month')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Listing' },
                    ],
                },
            },
        },
        NewListingCountsYtd: {
            label: 'New Listings - YTD',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        {
                            fileSubmissionDate: {
                                gte: this.now()
                                    .startOf('year')
                                    .toJSON(),
                            },
                        },
                        { origin: 'Listing' },
                    ],
                },
            },
        },
        ClosedFileCountsToday: {
            label: 'Closed Files - Today',
            type: 'dashboard',
            filter: {
                where: {
                    actualCloseDate: {
                        gte: this.now()
                            .startOf('date')
                            .toJSON(),
                    },
                },
            },
        },
        ClosedFileCountsWtd: {
            label: 'Closed Files - WTD',
            type: 'dashboard',
            filter: {
                where: {
                    actualCloseDate: {
                        gte: this.now()
                            .startOf('week')
                            .toJSON(),
                    },
                },
            },
        },
        ClosedFileCountsMtd: {
            label: 'Closed Files - MTD',
            type: 'dashboard',
            filter: {
                where: {
                    actualCloseDate: {
                        gte: this.now()
                            .startOf('month')
                            .toJSON(),
                    },
                },
            },
        },
        ClosedFileCountsYtd: {
            label: 'Closed Files - YTD',
            type: 'dashboard',
            filter: {
                where: {
                    actualCloseDate: {
                        gte: this.now()
                            .startOf('year')
                            .toJSON(),
                    },
                },
            },
        },
        FilesClosingThisWeek: {
            label: 'Files Closing This Week',
            type: 'dashboard',
            filter: {
                where: {
                    and: [
                        { estimatedCloseDate: { gte: this.now().toJSON() } },
                        {
                            estimatedCloseDate: {
                                lte: this.now()
                                    .add(10, 'days')
                                    .toJSON(),
                            },
                        },
                    ],
                },
            },
        },
    };
}



// WEBPACK FOOTER //
// ./src/dashboard/dashboard-filters.js